import { BaseContainerModel } from '../base-container.model';
import { bl_hc_patient_medical_test_attachment_RowClass, bl_hc_patient_medical_test_attachment_RowInterface } from '../../dbschema/bl_hc_patient_medical_test_attachment.model';


export class HcMedicalTestAttachmentContainerModel extends BaseContainerModel {
  bl_hc_patient_medical_test_attachment: bl_hc_patient_medical_test_attachment_RowInterface = new bl_hc_patient_medical_test_attachment_RowClass();
}